// extracted by mini-css-extract-plugin
module.exports = {"block":"wallets_block__HGQkH","title":"wallets_title__ON8aq","right":"wallets_right__8DT8x","available":"wallets_available__zloQN","balance":"wallets_balance__x0fzG"};